import { Mod } from "@/services/api";

export default {
   state: {
      plansList: []
   },

   mutations: {
      SET_PLANS(state, plansList) {
         state.plansList = plansList;
      }
   },

   actions: {
      async getPlans({ commit }, organization) {
         const plans = await Mod.find("plans", "list").get(organization);

         commit("SET_PLANS", plans.data.data);
         return plans.data;
      },
      async getPlanDetails(_, request) {
         const { data } = await Mod.find("plans", "list").get(request.org); // devolve array

         return { data: data.find(p => p.hashed_id === request.planHash) };
      }
   }
};
